module.exports = __webpack_public_path__ + "/images/cover-regalos-efectivo.c4c14b6.svg";